module.exports = __webpack_public_path__ + "static/media/complete-milestone.eb9bef11.svg";